import config from '../../config'

const getWorkOrderRemindersRequest = ({ airportId }) => ({
  method: 'get',
  url: `${config.baseUrl}/${airportId}/Reminders/WorkOrder`,
})

export default getWorkOrderRemindersRequest
